export default {
  en: {
    copy: 'Copy to clipboard',
  },
};
